import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { TranslationModule } from '@hdms/shared/feature';
import { ButtonModule, FlyoutModule, ScrollbarModule, SvgIconModule } from '@hdms/shared/ui-core';
import { AnalyticsModule, LetModule } from '@hdms/shared/util-core';

import { SearchCategoriesModule } from '../../header-search/search-categories/search-categories.module';
import { HeaderSearchInputModule } from '../../header-search/search-input/search-input.module';
import { SearchProductsModule } from '../../header-search/search-products/search-products.module';
import { SelectableLinksModule } from '../../header-search/selectable-links/selectableLinks.module';

import { HeaderSearchPopoverComponent } from './header-search-popover.component';

@NgModule({
  declarations: [HeaderSearchPopoverComponent],
  imports: [
    CommonModule,
    FlyoutModule,
    ButtonModule,
    SvgIconModule,
    TranslationModule,
    HeaderSearchInputModule,
    SearchCategoriesModule,
    SearchProductsModule,
    SelectableLinksModule,
    ScrollbarModule,
    LetModule,
    AnalyticsModule
  ],
  exports: [HeaderSearchPopoverComponent]
})
export class HeaderSearchPopoverModule {}
